export const bulletin = {
  createNew: "Create New Bulletin",
  edit: "Edit Bulletin",
  title: "Title",
  content: "Content",
  contentHelper: "Write your message to the team. You can include updates, announcements, or questions.",
  selectAudienceHelper: "Select who should see this bulletin",
  facilitators: "Facilitators",
  moderators: "Moderators",
  organisationAdmins: "Organisation Admins",
  superAdmins: "Super Admins"
}
